export default "__VITE_ASSET__jtau7DJF__"